module.exports = __webpack_public_path__ + "static/img/27.f54ef075.png";